var _ = require('underscore');

var reverse = require('django_js_front/reverse');

module.exports = function (env) {
    var staticPath = '/static/';

    if (typeof window !== 'undefined') {
        staticPath = window.app.settings.staticUrl;
    }

    env.addGlobal('static', function (file) {
        return staticPath + file;
    }, true);

    env.addGlobal('url', function (name) {
        return reverse[name]();
    });

    env.addGlobal('isMobile', function () {
        return window.app.settings.isMobile;
    });
};



//////////////////
// WEBPACK FOOTER
// ./nunjucks.config.js
// module id = 4
// module chunks = 0